/* Poolboy 10% offer system (Nugget, Oct 2026)
   Every capture point posts to Klaviyo list L1 Newsletter Subscribers,
   which triggers PB | Welcome (email 1 carries a unique one-use code).
   The cart drawer form also sends a Saved Cart event, which triggers
   PB | Saved cart (cart + checkout code). */
(function(){
  if(window.__pbo) return; window.__pbo=true;
  var C=window.PBO_CFG||{};
  /* Market routing (Oct 2026): AU visitors (poolboycollective.com / AU market) go to the AU list and are tagged Market=AU */
  var AU=(window.Shopify&&window.Shopify.country==='AU')||/poolboycollective\.com$/.test(location.hostname);
  var MARKET=AU?'AU':'NZ';
  var COMPANY=C.company||'X38Hb5', LIST=AU?(C.listAU||'RWn9cH'):(C.list||'VBV6kF'), REV='2024-10-15';
  var ARROW='<svg viewBox="0 0 22 12" aria-hidden="true"><path d="M0 6h20M15 1l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>';
  var html=document.documentElement;

  function get(k,s){try{return (s?sessionStorage:localStorage).getItem(k)}catch(e){return null}}
  function put(k,v,s){try{(s?sessionStorage:localStorage).setItem(k,v)}catch(e){}}
  function subbed(){return get('pbo_sub')==='1'||C.customerSubscribed===true}
  function markSub(){put('pbo_sub','1');html.classList.add('pbo-subbed');var t=document.querySelector('.pbo-tab');if(t)t.classList.remove('is-on');}
  if(subbed()) html.classList.add('pbo-subbed');

  function post(path,body){
    return fetch('https://a.klaviyo.com/client/'+path+'/?company_id='+COMPANY,{method:'POST',headers:{'Content-Type':'application/vnd.api+json','revision':REV},body:JSON.stringify(body)})
      .then(function(r){if(r.status<200||r.status>=300)throw new Error(r.status);return r;});
  }
  function subscribe(email,source){
    return post('subscriptions',{data:{type:'subscription',attributes:{custom_source:source+(AU?' (AU)':''),profile:{data:{type:'profile',attributes:{email:email}}}},relationships:{list:{data:{type:'list',id:LIST}}}}});
  }
  function saveCart(email){
    return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(cart){
      if(!cart||!cart.items||!cart.items.length) return null;
      var base=location.origin;
      var items=cart.items.map(function(i){return {title:i.product_title,variant:(i.variant_title||''),quantity:i.quantity,price:(i.final_line_price/100).toFixed(2),image:(i.image||'').replace(/^\/\//,'https://'),url:base+i.url}});
      var link=base+'/cart/'+cart.items.map(function(i){return i.variant_id+':'+i.quantity}).join(',');
      return post('events',{data:{type:'event',attributes:{
        properties:{market:MARKET,currency:cart.currency,items:items,item_count:cart.item_count,cart_total:(cart.total_price/100).toFixed(2),cart_url:link,first_item_title:items[0].title,first_item_image:items[0].image},
        value:cart.total_price/100,unique_id:'pbo-'+Date.now(),
        metric:{data:{type:'metric',attributes:{name:'Saved Cart'}}},
        profile:{data:{type:'profile',attributes:{email:email}}}}}});
    });
  }
  function identify(email){try{if(window.klaviyo&&typeof window.klaviyo.identify==='function')window.klaviyo.identify({email:email,Market:MARKET});}catch(e){}}
  function track(source){
    try{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'newsletter_signup',offer:'10',location:source});}catch(e){}
    try{if(typeof window.fbq==='function')window.fbq('track','Lead',{content_name:'10% signup',content_category:source});}catch(e){}
  }

  /* forms: one handler for all of them */
  document.addEventListener('submit',function(e){
    var f=e.target; if(!f.classList||!f.classList.contains('pbo-form')) return;
    e.preventDefault();
    var input=f.querySelector('input[type=email]'), btn=f.querySelector('.pbo-go'), msg=f.querySelector('.pbo-msg');
    var email=(input.value||'').trim().toLowerCase(), source=f.getAttribute('data-pbo-source')||'Website';
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)){msg.textContent='That email does not look right. Check it and try again.';input.focus();return;}
    msg.textContent=''; btn.disabled=true;
    var jobs=[subscribe(email,source)];
    if(f.hasAttribute('data-pbo-cart')) jobs.push(saveCart(email).catch(function(){return null}));
    Promise.all(jobs).then(function(){
      identify(email); track(source); markSub();
      var scope=f.closest('[data-pbo-scope]')||f.parentNode;
      var at=scope.querySelector('[data-pbo-email]'); if(at) at.textContent=email;
      scope.classList.add('is-done');
      var focus=scope.querySelector('.pbo-done [tabindex],.pbo-done button,.pbo-done a'); if(focus) try{focus.focus({preventScroll:true})}catch(_){}
    }).catch(function(){
      btn.disabled=false; msg.textContent='That did not go through. Try again in a moment.';
    });
  });

  /* expanders: product page line and cart drawer */
  document.addEventListener('click',function(e){
    var t=e.target.closest&&e.target.closest('[data-pbo-toggle]'); if(!t) return;
    var p=document.getElementById(t.getAttribute('aria-controls')); if(!p) return;
    var open=t.getAttribute('aria-expanded')!=='true';
    t.setAttribute('aria-expanded',open?'true':'false'); p.hidden=!open;
    if(open){var i=p.querySelector('input[type=email]'); if(i) setTimeout(function(){try{i.focus({preventScroll:true})}catch(_){i.focus()}},60);}
  });

  /* popup and tab */
  var pop=document.querySelector('.pbo-pop'), tab=document.querySelector('.pbo-tab'), lastFocus=null, timer=null;
  function isOpen(){return pop&&!pop.hidden}
  function open(manual){
    if(!pop||isOpen()) return;
    lastFocus=document.activeElement; pop.hidden=false; pop.setAttribute('aria-hidden','false');
    html.classList.add('pbo-lock'); if(tab) tab.classList.remove('is-on');
    requestAnimationFrame(function(){requestAnimationFrame(function(){pop.classList.add('is-open')})});
    put('pbo_shown','1',true);
    if(window.innerWidth>899){var i=pop.querySelector('input[type=email]'); if(i) setTimeout(function(){try{i.focus({preventScroll:true})}catch(_){}} ,500);}
  }
  function close(){
    if(!isOpen()) return;
    pop.classList.remove('is-open'); html.classList.remove('pbo-lock'); pop.setAttribute('aria-hidden','true');
    if(!pop.classList.contains('is-done')) put('pbo_dismiss',String(Date.now()));
    setTimeout(function(){pop.hidden=true; if(tab&&!subbed()) tab.classList.add('is-on');},420);
    if(lastFocus&&lastFocus.focus) try{lastFocus.focus({preventScroll:true})}catch(_){}
  }
  if(pop){
    pop.addEventListener('click',function(e){if(e.target.closest('[data-pbo-close]')){e.preventDefault();close();}});
    document.addEventListener('keydown',function(e){if(e.key==='Escape') close();});
  }
  if(tab) tab.addEventListener('click',function(){open(true)});

  function drawerOpen(){var d=document.querySelector('cart-drawer');return !!(d&&(d.classList.contains('active')||d.hasAttribute('open')))}
  function blockedPath(){return /^\/(cart|checkouts?|account|challenge|password)/.test(location.pathname)}
  function recentlyDismissed(){var d=parseInt(get('pbo_dismiss')||'0',10);return d&&(Date.now()-d)<7*864e5}

  function arm(){
    if(!pop||subbed()||blockedPath()) return;
    setTimeout(function(){ if(!subbed()&&tab) tab.classList.add('is-on'); },2500);
    if(recentlyDismissed()||get('pbo_shown',true)==='1'||C.customer===true) return;
    var fired=false, start=Date.now(), delay=(C.delay||15)*1000;
    function fire(){
      if(fired||subbed()) return;
      if(drawerOpen()||document.visibilityState!=='visible'){clearTimeout(timer);timer=setTimeout(fire,5000);return;}
      fired=true; window.removeEventListener('scroll',onScroll); open(false);
    }
    function onScroll(){
      var h=document.documentElement, max=h.scrollHeight-h.clientHeight;
      if(max>0&&(h.scrollTop||window.pageYOffset)/max>=.5&&Date.now()-start>6000) fire();
    }
    timer=setTimeout(fire,delay);
    window.addEventListener('scroll',onScroll,{passive:true});
    try{
      if(window.klaviyo&&typeof window.klaviyo.isIdentified==='function'){
        Promise.resolve(window.klaviyo.isIdentified()).then(function(id){if(id){fired=true;clearTimeout(timer);}}).catch(function(){});
      }
    }catch(e){}
  }

  /* product page line, placed under add to cart */
  function pdp(){
    if(subbed()) return;
    var tpl=document.getElementById('pbo-pdp-tpl'), btn=document.querySelector('.pb-ph__add');
    if(!tpl||!btn||document.querySelector('.pbo-pdp')) return;
    var node=tpl.content.firstElementChild.cloneNode(true);
    var anchor=btn.closest('form')||btn.parentElement;
    anchor.parentNode.insertBefore(node,anchor.nextSibling);
  }

  function boot(){ pdp(); arm(); document.querySelectorAll('.pbo-go').forEach(function(b){ if(!b.querySelector('svg')) b.insertAdjacentHTML('beforeend',ARROW); }); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();

  /* homepage band image settle */
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}})},{threshold:.2});
    document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('.pbo-band').forEach(function(b){io.observe(b)})});
  }
  /* cart drawer re-renders replace its markup, so arrows need adding again */
  document.addEventListener('click',function(e){ if(e.target.closest&&e.target.closest('.pbo-cart__t')){ var p=document.querySelector('.pbo-cart .pbo-go'); if(p&&!p.querySelector('svg')) p.insertAdjacentHTML('beforeend',ARROW);} });

  window.PBO={open:open,close:close,market:MARKET,list:LIST};
})();
